import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online Meldformulier',
  api_endpoint: 'https://api.straatbeeld.online/',
  sentry: {
    dsn: 'https://69e4cab4867dbff48feccc952e83bfd7@o4507735602298880.ingest.de.sentry.io/4508734002430032',
    version: version
  }
};
